import template from './tooltip.tpl';
import DomUtil from '@/core/utils/domUtil';
import styles from './tooltip.module.scss';

export default  class Tooltip {
    public MARGIN_VERTICAL: number;
    public MAX_WIDTH: number;
    private _target: HTMLElement | null;
    public element: HTMLElement | null;

    constructor(link, headline, text) {

        this.MARGIN_VERTICAL = 20;
        this.MAX_WIDTH = 500;

        this._target = null;
        this.element = document.createElement('span');
        this.element.innerHTML = template({link: link, text: text, headline: headline, styles: styles});
        this.element = this.element.firstChild as HTMLElement;
    }

    private get isTouchDevice(): boolean {
        return (
            'ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            // @ts-expect-error - for older browsers
            navigator.msMaxTouchPoints > 0
        );
    }

    preapare(link) {


            const span = link.querySelector('span.overlay_text');

            const closeButton = link.querySelector('span.overlay_close_button');

            // show close button an add click listener
            if (this.isTouchDevice) {

                if (closeButton) {
                    closeButton.style.display = 'flex';
                    closeButton.addEventListener('click', () => {
                        this.hideOverlay(span);
                    });
                }

            }

// we are on a screen device with pointer, so we can use mouseover
            link.addEventListener('mouseover', () => {
                this.showOverlay(span, link);
            });

            link.addEventListener('mouseout', () => {
                this.hideOverlay(span);
            });

            link.addEventListener('click', (event) => {

                if (event.target == link || (event.target ).parentNode == link)
                {
                    this.showOverlay(span, link);
                }

            });
    }



 hideOverlay (span) {
    span.style.display = 'none';
}

 showOverlay (span, link) {
    // first show the element to be able to caluclate the dimensions
    span.style.display = 'block';
    span.style.zIndex = '1000';

    // caluclate position

    const new_max_width = Math.min(window.innerWidth - 2 * this.MARGIN_VERTICAL, this.MAX_WIDTH - 2 * this.MARGIN_VERTICAL);
    span.style.minWidth = 150 +'px';
    span.style.maxWidth = new_max_width + 'px';
    span.style.top = - 10- span.offsetHeight +'px';
    span.style.left =  -span.offsetWidth + link.offsetWidth +'px';

}

    destroy() {

        if (this._target && this.element && DomUtil.isDescendant(this._target, this.element)) {
            this._target.removeChild(this.element);
        }

        this.element = null;
    }

    appendTo(target) {

        this._target = target;
        if (this.element && this._target) {
            this._target.appendChild(this.element);
            this.preapare(this.element);
        }

    }

}
